export const forEach=(arr,fn)=>{
  if(!arr.length || !fn) return
  let i = -1
  let len = arr.length
  while(++i < len){
    let item = arr[i]
    fn(item,i,arr)
  }
}

/**
 * 防抖函数
 * @param fn
 * @param wait
 * @returns {function(...[*]=)}
 */
export const debounceSync = (fn, wait, immediate = false) => {
  let timer = null
  let isInvoke = false
  const _debounce = function () {
    let context = this
    let args = arguments
    return new Promise((resolve, reject) => {
      if (timer) clearTimeout(timer)

      if (immediate && !isInvoke) {
        const result = fn.apply(context, args)
        resolve(result)
        isInvoke = true
      } else {
        timer = setTimeout(()=>{
          const result = fn.apply(context, args)
          resolve(result)
          isInvoke = false
          timer = null
        },wait)
      }
    })
  }

  _debounce.cancel = function () {
    if (timer) clearTimeout(timer)
    timer = null
    isInvoke = false
  }

  return _debounce
}

export const debounce = (fn, wait, immediate = false) => {
  let timer;

  return function() {
    let context = this;
    let args = arguments;
    if (timer) clearTimeout(timer);
    if (immediate) {
      var callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait)
      if (callNow) fn.apply(context, args)
    } else {
      timer = setTimeout(function() {
        fn.apply(context, args)
      }, wait);
    }
  }
}

//交集
export const getIntersection = (arr1,arr2)=>{
  let len = Math.min(arr1,length,arr2.length)
  let i = -1;
  let res = []
  while(++i < len){
    const item = arr2[i]
    if(arr1.indexOf(item) > -1) res.push(item)
  }
  return res
}
//并集
export const getUnion = (arr1, arr2) => {
  return Array.from(new Set([...arr1,...arr2]))
}

export const getDiff = (arr1,arr2) => {
  let isNaN = Number.isNaN
  return arr1.reduce((previous,i)=>{
    let found = arr2.findIndex(j=>{
      return j === 1 || (isNaN(i) && isNaN(j))
    })
    return (found < 0 && previous.push(i), previous)
  },[])
}

export const getDiff2 = (arr1, arr2) => {
  let set1 = new Set(arr1);
  let set2 = new Set(arr2);
  let subset = [];
  for (let item of set1) {
    if (!set2.has(item)) {
      subset.push(item);
    }
  }
  return subset;
}

//判断要查询的数组是否至少有一个元素包含在目标数组中
export const hashOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1)
}

export const scalarArrayEquals = (arr1, arr2) => {
  return arr2.length === arr2.length && JSON.stringify(arr1.sort()) === JSON.stringify(arr2.sort())
}

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = timeStamp => {
 const timeStr = String(timeStamp)
  return timeStr.length > 10
}

/**
 * 获取2个时间差
 * @param startTime
 * @param endTime
 * @param diffType
 */
export const dateDiff = (startTime,endTime,diffType) => {
  startTime = startTime.replace(/\-/g, "/")
  endTime = endTime.replace(/\-/g, "/")
  diffType = diffType.toLowerCase()
  var sTime = new Date(startTime)
  var eTime = new Date(endTime)
  var timeType =1;
  switch (diffType) {
    case"second":
      timeType =1000
      break
    case"minute":
      timeType =1000*60
      break
    case"hour":
      timeType =1000*3600
      break
    case"day":
      timeType =1000*3600*24
      break
    default:
      break
  }
  return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType))
}
/**
 * 时间戳转时间格式
 * @param {*} timestamp
 * @returns
 */
 export const timestampToTime= (timestamp) =>{
  var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  var D = date.getDate() + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  return Y+M+D+h+m+s;
}

export const getTime = (time) => {
  if (!time || time == 0) {
    return '00:00:00'
  }
  let h = parseInt(time / 60 / 60 % 24)
  let m = parseInt(time / 60 % 60)
  let s = parseInt(time % 60)
  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  s = s < 10 ? '0' + s : s
  return `${h}:${m}:${s}`
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
  return timeStamp < currentTime
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
 return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
export const getDate = (timeStamp, startType) => {
  const d = new Date(timeStamp * 1000)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth()+1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = ''
  if(startType === 'year') resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
  else resStr = month + '-' + date + ' ' + hours + ':' + second
  return resStr
}

export const makeDurationToSeconds = (time) => {
  let str = time
  if (!str) {
    return 0
  }
  let arr = str.split(':')
  let hs = parseInt(arr[0]*3600)
  let ms = parseInt(arr[1]*60)
  let ss = parseInt(arr[2])
  let seconds = hs+ms+ss
  return seconds
}

export const getFormatDate = (fmt,date)=>{
  let ret;
  let opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    }
  }
  return fmt;
}

export const formatGMT8ToStandard = (time) => {
  if (!time) return ''
  let dateObj;
  if (time instanceof Date) {
    dateObj = time
  }else if (typeof time === 'string' && isGMT8Format(time)) {
    dateObj = new Date(time)
  }else if (typeof time === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(time)) {
    return time;
  }else {
    dateObj = new Date(time);
  }
  // 如果转换失败，返回空字符串
  if (isNaN(dateObj.getTime())) {
    return '';
  }

  // 格式化为标准字符串
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const hours = String(dateObj.getHours()).padStart(2, '0');
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const isGMT8Format = (time) => {
  if (!time) return false
  if (time instanceof Date) return true
  if (typeof time === 'string'){
    return time.includes('GMT+0800') || time.includes('GMT+08:00') ||
      time.includes('中国标准时间') || /[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4}/.test(time);
  }
  return false
}
/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = timeStamp => {
  // 判断当前传入的时间戳是秒格式还是毫秒
  const IS_MILLISECOND = isMillisecond(timeStamp)
  // 如果是毫秒格式则转为秒格式
  if (IS_MILLISECOND) Math.floor(timeStamp /= 1000)
  // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
  timeStamp = Number(timeStamp)
  // 获取当前时间时间戳
  const currentTime = Math.floor(Date.parse(new Date()) / 1000)
  // 判断传入时间戳是否早于当前时间戳
  const IS_EARLY = isEarly(timeStamp, currentTime)
  // 获取两个时间戳差值
  let diff = currentTime - timeStamp
  // 如果IS_EARLY为false则差值取反
  if (!IS_EARLY) diff = -diff
  let resStr = ''
  const dirStr = IS_EARLY ? '前' : '后'
  // 少于等于59秒
  if (diff <= 59) resStr = diff + '秒' + dirStr
  // 多于59秒，少于等于59分钟59秒
  else if (diff > 59 && diff <= 3599) resStr = Math.floor(diff / 60) + '分钟' + dirStr
  // 多于59分钟59秒，少于等于23小时59分钟59秒
  else if (diff > 3599 && diff <= 86399) resStr = Math.floor(diff / 3600) + '小时' + dirStr
  // 多于23小时59分钟59秒，少于等于29天59分钟59秒
  else if (diff > 86399 && diff <= 2623859) resStr = Math.floor(diff / 86400) + '天' + dirStr
  // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
  else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) resStr = getDate(timeStamp)
  else resStr = getDate(timeStamp, 'year')
  return resStr
}

/**
 * 获取2个日期相隔的所有日期
 * @param starDay
 * @param endDay
 */
export const getDayAll = (starDay, endDay) => {
  let arr = []
  let dates = []
  let db = new Date(starDay)
  let de = new Date(endDay)

  let s = db.getTime() - 24 * 60 * 60 * 1000
  let d = de.getTime() - 24 * 60 * 60 * 1000
  for (let i = s; i <= d;) {
    i = i + 24 * 60 * 60 * 1000
    arr.push(parseInt(i))
  }

  for (let j in arr) {
    let time = new Date(arr[j])
    let mouth = (time.getMonth() + 1) >= 10 ? (time.getMonth() + 1) : ('0' + (time.getMonth() + 1))
    let day = time.getDate() >= 10 ? time.getDate() : ('0' + time.getDate())
    if (isNaN(mouth)) {
      continue
    }
    let MMDD = mouth + '-' + day
    dates.push(MMDD)
  }
  return dates
}

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
  const ua = window.navigator.userAgent
  const isExplorer = (exp) => {
    return ua.indexOf(exp) > -1
  }
  if (isExplorer('MSIE')) return 'IE'
  else if (isExplorer('Firefox')) return 'Firefox'
  else if (isExplorer('Chrome')) return 'Chrome'
  else if (isExplorer('Opera')) return 'Opera'
  else if (isExplorer('Safari')) return 'Safari'
}

export const uuid2=(len,radix)=>{
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  let uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
}
/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) return key in obj
  else {
    let keysArr = Object.keys(obj)
    return keysArr.length
  }
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1)
}


/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) return false
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true
  /* eslint-disable-next-line */
  else return !keysArr1.some(key => obj1[key] != obj2[key])
}

export const compare = (origin,target,k)=>{
  if (typeof target !== "object") {
    return origin === target
  }
  if (typeof origin !== "object") {
    return false
  }
  for (let key of Object.keys(target)) {
    if (k){
      if (k === key) {
        return compare(origin[key], target[key],k);
      }else{
        compare(origin[key], target[key],k);
      }
    }else {
      if (!compare(origin[key], target[key],k)) {
        return false
      }
    }
  }
  return true
}

/*根据 对象的order字段排序*/
export const sortOrder = (obj1,obj2)=>{
  return obj1.order - obj2.order
}

/*根据 对象的order_index字段排序*/
export const sortOrderIdex = (obj1,obj2)=>{
  return obj1.order_index - obj2.order_index
}

export const sortObject = (propertyName,sortType)=>{
  return (o1,o2)=>{
    let v1 = o1[propertyName]
    let v2 = o2[propertyName]
    if(isNumber(v1) && isNumber(v2)){//数字就转换成数字
      v1 = Number(v1)
      v2 = Number(v2)
    }
    if(v2 < v1){
      return sortType === 'asc' ? 1 : -1
    }else if (v2 > v1){
      return sortType === 'asc' ? -1 : 1
    }else {
      return 0
    }
  }
}

/*判断是否是整数或浮点数*/
export const isNumber = (val) => {
  let regPos = /^\d+(\.\d+)?$/
  let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
  return regPos.test(val) || regNeg.test(val)
}

/*file 转 base64*/
export const fileToBase64 = (file, callBack) => {
  let reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    callBack(reader.result)
  }
}

/*base64 to file*/
export const base64toFile = (base64,filename) => {
  let arr = base64.split(','),mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]),n = bstr.length,u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr],filename,{type:mime})
}

/*base64 转 blob*/
export const dataURItoBlob = (base64Data) =>{
  let byteString;
  if (base64Data.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(base64Data.split(',')[1]);
  } else {
    byteString = unescape(base64Data.split(',')[1])
  }
  let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
  let ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  let blob = new Blob([ia],{type:mimeString})
  return blob
}

/*blob to base64*/
export const blobToDataURI = (blob,callBack) =>{
  let reader = new FileReader()
  reader.readAsDataURL(blob)
  reader.onload = ()=> {
    callBack(reader.result)
  }
}

/*数组去重*/
export const uniqueArray = (array, key) => {
  if(array.length<1)return null;
  let result = [array[0]]
  for(let i = 1; i < array.length; i++){
    let item = array[i];
    let repeat = false;
    for (let j = 0; j < result.length; j++) {
      if (item[key] === result[j][key]) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      result.push(item);
    }
  }
  return result;
}

export const diffList = (arr1,arr2,key) => {
  let clone = arr1.slice(0)
  for (let i = 0; i < arr2.length; i++) {
    let temp = arr2[i]
    for (let j = 0; j < clone.length; j++) {
      if (temp[key] === clone[j][key]) {
        clone.splice(j,1)
      }
    }
  }
  return uniqueArray(clone,key)
}


/*数组切割*/
export const diviceGroup = (array, subGroupLength)=>{
  let index = 0;
  let newArray = [];
  while(index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength));
  }
  return newArray;
}

/*base64加密*/
export const base64Encode = (input) => {
  let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4, i = 0, output = '', utftext = '';
  input = input.replace(/\r\n/g, "\n");
  for (let n = 0; n < input.length; n++) {
    let c = input.charCodeAt(n);
    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if ((c > 127) && (c < 2048)) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }

  }
  while (i < utftext.length) {
    chr1 = utftext.charCodeAt(i++);
    chr2 = utftext.charCodeAt(i++);
    chr3 = utftext.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;
    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }
    output = output +
      _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
      _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
  }
  return output;
}

export const base64Decode = (input) => {
  let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4, i = 0, output = '';
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  while (i < input.length) {
    enc1 = _keyStr.indexOf(input.charAt(i++));
    enc2 = _keyStr.indexOf(input.charAt(i++));
    enc3 = _keyStr.indexOf(input.charAt(i++));
    enc4 = _keyStr.indexOf(input.charAt(i++));
    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;
    output = output + String.fromCharCode(chr1);
    if (enc3 != 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 != 64) {
      output = output + String.fromCharCode(chr3);
    }
  }
  let string = '', c = 0, c1 = 0, c2 = 0, c3 = 0;
  i = 0;
  while (i < output.length) {
    c = output.charCodeAt(i);
    if (c < 128) {
      string += String.fromCharCode(c);
      i++;
    } else if ((c > 191) && (c < 224)) {
      c2 = output.charCodeAt(i + 1);
      string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
      i += 2;
    } else {
      c2 = output.charCodeAt(i + 1);
      c3 = output.charCodeAt(i + 2);
      string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
      i += 3;
    }
  }
  return string;
}

/**
 *
 * @param type
 * @param value
 */
export const validateNumber = (type,value) => {
  let z_reg = ''
  switch (type) {
    case 0:
      z_reg = /^(([0-9])|([1-9]([0-9]+)))(.[0-9]+)?$/
      break
    case 1:
      z_reg = /^(-)?(([0-9])|([1-9]([0-9]+)))(.[0-9]+)?$/
      break
    case 2:
      z_reg = /^(([0-9])|([1-9]([0-9]+)))$/
      break
    case 3:
      z_reg = /^(-)?(([0-9])|([1-9]([0-9]+)))$/
      break
    case 4:
      z_reg = /^(([0-9])|([1-9]([0-9]+)))(.[0-9]+)$/
      break
    case 5:
      z_reg = /^(-)?(([0-9])|([1-9]([0-9]+)))(.[0-9]+)$/
      break
    case 6:
      z_reg = /^(([0-9])|([0-9]([0-9]+)))$/
      break
    case 7:
      z_reg = /^([0-9]*)$/
      break
    default:
      z_reg = /^(([0-9])|([1-9]([0-9]+)))(.[0-9]+)?$/
      break
  }
  return z_reg.test(value)
}
// 将秒转换成时分秒
export function formatSeconds(seconds){
  if(!seconds){
    seconds = 0;
  }
  let theTime = parseInt(seconds);// 秒
  let middle= 0;// 分
  let hour= 0;// 小时

  if(theTime > 60) {
    middle= parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if(middle> 60) {
      hour= parseInt(middle / 60);
      middle= parseInt(middle % 60);
    }
  }
  let result = ":"+(parseInt(theTime) < 10 ? "0"+parseInt(theTime) : parseInt(theTime));
  if(middle > 0) {
    result = ":"+(parseInt(middle) < 10 ? "0"+parseInt(middle) : parseInt(middle)) + result;
  }else{
    result = ":00" + result;
  }
  if(hour> 0) {
    result = (parseInt(hour) < 10 ? "0" + parseInt(hour) : parseInt(hour)) + result;
  }else{
    result = "00" + result;
  }
  return result;
}

export const toFixed = (value, bit) => {
  let pow = Math.pow(10, bit)
  let arr = (value*pow).toString().split('.')
  let result = ''
  if (arr[1] && arr[1].split('')[0] > 4) {
    result = (Number(arr[0])+1) / pow
  }else {
    result = arr[0] / pow
  }
  result = result.toString()
  if (bit<=0) return result
  let hasBit = result.split('.')[1] ? result.split('.')[1].length : 0
  result = result + new Array(bit - hasBit + 1).join('0')
  return parseFloat(result)
}

export const isFull = () =>{
  const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
  return screen.height == clientHeight
}

export const isValueNumber = (value) => {
  return (/^[1-9][0-9]*$/).test(value + '')
}

export const isPlayingVideoStream = (videoElement,options={})=>{
  const {
    checkInterval = 1000,
    stallThreshold = 2000,
    callback = () =>{}
  } = options

  let isPlaying = false
  let lastTimeUpdate = 0
  let timer
  videoElement.addEventListener('play',()=>{
    isPlaying = true
    callback(true)
  })
  videoElement.addEventListener('pause',()=>{
    isPlaying = false
    callback(false)
  })
  videoElement.addEventListener('ended',()=>{
    isPlaying = false
    callback(false)
  })
  videoElement.addEventListener('timeupdate',()=>{
    lastTimeUpdate = Date.now()
  })
  videoElement.addEventListener('error',()=>{
    isPlaying = false
    callback(false)
  })

  function startMonitoring() {
    if (videoElement.readyState < 2) {
      videoElement.addEventListener('loadeddata',startMonitoring)
      return
    }
    timer = setInterval(()=>{
      if (isPlaying && videoElement.currentTime > 0) {
        const timeSinceLastUpdate = Date.now() - lastTimeUpdate
        if (timeSinceLastUpdate > stallThreshold) {
          isPlaying = false
          callback(false)
        }else if (!isPlaying) {
          isPlaying = true
          callback(true)
        }
      }
    },checkInterval)
  }

  function stopMonitoring() {
    clearInterval(timer)
    videoElement.removeEventListener('loadeddata',startMonitoring)
  }

  startMonitoring()

  return{
    start: startMonitoring,
    stop: stopMonitoring
  }
}

/**
 * 动态调整发送端编码质量
 * @param {RTCRtpSender} sender - 视频发送者对象
 * @param {string} quality - 质量等级 'good' | 'unstable' | 'poor'
 * @param {Object} currentStats - 当前统计信息（可选，用于决策）
 */
export const adjustEncodingQuality = (sender,quality,currentStats={})=>{
  if (!sender || !sender.track || sender.track.kind !== 'video') {
    console.log('Invalid sender or sender track')
    return
  }
  const params = sender.getParameters()
  if (!params.encodings || params.encodings.length === 0) {
    params.encodings = [{}];
  }

  const qualityParams = {
    good: {
      maxBitrate: 2000000,   // 2 Mbps
      maxFramerate: 30,
      scaleResolutionDownBy: 1
    },
    unstable: {
      maxBitrate: 1000000,   // 1 Mbps
      maxFramerate: 20,
      scaleResolutionDownBy: 1.5
    },
    poor: {
      maxBitrate: 500000,    // 500 kbps
      maxFramerate: 15,
      scaleResolutionDownBy: 2
    }
  }
  const target = qualityParams[quality]
  if (!target) return;
  const currentBitrate = params.encodings[0].maxBitrate
  const currentFramerate = params.encodings[0].maxFramerate
  if (currentBitrate === target.maxBitrate && currentFramerate === target.maxFramerate) {
    return;
  }
  params.encodings[0].maxBitrate = target.maxBitrate
  params.encodings[0].maxFramerate = target.maxFramerate

  sender.setParameters(params)
    .then(()=>{
      console.log(`Adjusted encoding quality to ${quality}`)
    })
    .catch((error)=>{
      console.error('Error adjusting encoding quality:', error)
    })
}



// WEBPACK FOOTER //
// ./src/libs/tools.js